export default {
    mounted(){
        $(window).trigger('resize');
    }
}